<template>
  <div>
    <Top/>
      <div class="cght_htmainbox cght_htmainboxnobg">
        <div class="cght_htmain cgw1216">
          <!--内容区域 开始-->
          <div class="cght_zhifutishi">
            <div class="cght_zhifutishia"><i class="iconfont">&#xe60f;</i></div>
            <div class="cght_zhifutishib">
              <div>订单提交成功！ 订单号：{{this.order.order_id}}</div>
            </div>
          </div>
          <div class="cght_zhifuxx"><em>订单信息</em></div>
          <div class="cght_zhifuxxword">
            <div class="cght_zhifuxxword1">收货地址：{{this.order.province}}-{{this.order.city}}-{{this.order.district}}</div>
            <div class="cght_zhifuxxword1">收货人：{{this.order.address_name}}</div>
            <div class="cght_zhifuxxword1">手机号码：{{this.order.tel}}</div>
            <div class="cght_zhifuxxword1" v-if="this.order.remark">备注：{{this.order.remark}}</div>
            <!-- <div class="cght_zhifuxxword1">
              <div class="cght_zhifuxxword1a">商品名称：</div>
              <div class="cght_zhifuxxword1b">
                <span>
                  产品名称
                  <em class="cght_zhifuxxword1bsz">x10个</em>
                  <em class="cght_zhifuxxword1bqs">￥135.35</em>
                  <br/>
                </span>
              </div>
            </div> -->
          </div>
          <!-- <div class="cght_height50"></div> -->
          <div class="cght_zhifufs">
            <div class="cght_zhifufsti" id="myPayType">支付方式</div>
            <div class="cght_tjddqrxxl" style="float: inherit;">
              <!-- <a href="JavaScript:void (0);" pay_type="1" class="cght_tjddqrxxl_axz">货到付款</a>
              <a href="JavaScript:void (0);" pay_type="2">在线支付</a> -->
              <div class="cght_zhifufsxx">
              <!---->
                <a href="javascript:void(0);" class="cght_zhifufsxx3" :class="peyType==1?'cght_zhifufsxxxz':''" @click="selectType(1)">微信</a>
                <a href="javascript:void(0);" class="cght_zhifufsxx1" :class="peyType==2?'cght_zhifufsxxxz':''" @click="selectType(2)">支付宝</a>
            </div>
            </div>
            <div class="cght_zhifufsxxshow cght_zhifufsxx3show">
              <div class="cght_zhifufsxx3showbox">
                <!-- <div class="cght_zhifufsxx3showw">距离二维码过期还剩<em>54</em>秒，过期后请刷新页面重新获取二维码。</div> -->
                <div class="cght_zhifufsxx3show1">
                  <div class="cght_zhifufsxx3show1left">
                    <div class="cght_zhifufsxx3show1leftt" v-loading="loading">
                      <div id="qrcodeImg"></div>
                    </div>
                    <div class="cght_zhifufsxx3show1leftb">
                      <img src="../../assets/images/zhifuweixin2.jpg" width="300" height="60" v-if="peyType ==1"/>
                      <img src="../../assets/images/zhifubao2.jpg" width="300" height="60" v-if="peyType ==2"/>
                    </div>
                  </div>
                  <div class="cght_zhifufsxx3show1right">
                    <img src="../../assets/images/zhifuweixin.jpg" v-if="peyType ==1"/>
                    <img src="../../assets/images/zhifubao.jpg" v-if="peyType ==2"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cght_zhifutjdd">
            <!-- <a href="javascript:void(0);" class="cght_zhifutjdda">立即支付</a> -->
            <em class="cght_zhifutjddzj">总金额：</em>
            <em class="cght_zhifutjddjqds">￥{{order.total_amount}}</em>
          </div>
          <!--内容区域 完成-->
        </div>
      </div>
    <Bottom/>
  </div>
</template>
<script>
import Top from '@/components/Member/Top'
import Bottom from '@/components/Member/Bottom'
import { mapGetters } from 'vuex'
import QRcode from 'qrcodejs2'
import api from '@/api/pay'

export default {
  name: 'ToPay',
  components: { Top, Bottom },
  data () {
    return {
      cartGoodsList: [],
      order: [],
      time: '',
      peyType: 1,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['current_user']),
    totalPrice () {
      let totalPrice = 0
      this.cartGoodsList.map(res => {
        totalPrice += res.number * res.tax_price
      })
      return totalPrice.toFixed(2)
    }
  },
  mounted () {
    this.payOrder_id = localStorage.getItem('payOrder_id')
    if (!this.payOrder_id) {
      this.$router.push({path: '/MyOrder'})
      return
    }
    this.getOnlyOrder(this.payOrder_id)
  },
  methods: {
    qrcode (url) {
      return new QRcode('qrcodeImg', {
        width: 248,
        height: 248,
        text: url,
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    getOnlyOrder (payOrderIid) {
      api.getOnlyOrder({order_id: payOrderIid}).then(res => {
        this.order = res.items
        this.toAlipay()
      })
    },
    toAlipay () {
      this.loading = true
      api.toAlipay({order_no: this.order.order_id, peyType: this.peyType}).then(res => {
        this.qrcode(res.item)
        this.loading = false
      })
      this.time = setInterval(() => {
        this.gePayType()
      }, 2000)
    },
    gePayType () {
      // 获取不到当前页面demo时清除定时器
      if (document.getElementById('myPayType') === null) {
        clearInterval(this.time)
        return
      }
      api.gePayType({order_id: this.order.order_id}).then(res => {
        if (res.items === 1) {
          this.$message({
            message: '支付成功',
            type: 'success'
          })
          clearInterval(this.time)
          this.$router.push({path: '/MyOrder'})
        }
      })
    },
    selectType (type) {
      document.getElementById('qrcodeImg').innerHTML = ''
      this.peyType = type
      clearInterval(this.time)
      this.toAlipay()
    }
  }
}
</script>
<style scoped>
  .cght_zhifuxxword{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/view/cart/toPay.vue